export enum ReactMutationKeys {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  SUBMIT_CONFIGURATION_WITH_WEBHOOK = 'SUBMIT_CONFIGURATION_WITH_WEBHOOK',
  ADD_TO_SHOPPING_CART = 'ADD_TO_SHOPPING_CART',
  POST_CARD_ORDER = 'POST_CARD_ORDER',
  CREATE_QUOTATION = 'CREATE_QUOTATION',
  DOWNLOAD_QUOTATION_PDF = 'DOWNLOAD_QUOTATION_PDF',
  CLOSE_QUOTATION = 'CLOSE_QUOTATION',
  UPDATE_QUOTATION_LINE = 'UPDATE_QUOTATION_LINE',
  CREATE_ORDERS_FROM_QUOTATION = 'CREATE_ORDERS_FROM_QUOTATION',
  DELETE_SHOPPING_CART_ITEM = 'DELETE_SHOPPING_CART_ITEM',
  EDIT_SHOPPING_CART_ITEM = 'EDIT_SHOPPING_CART_ITEM',
  DUPLICATE_CART_LINE = 'DUPLICATE_CART_LINE',
  EDIT_USER_DATA = 'EDIT_USER_DATA',
  RESET_PASSWORD = 'RESET_PASSWORD',
  REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET',
  REGISTER = 'REGISTER',
  SUBMIT_VISIBILITY_CONFIGURATION = 'SUBMIT_VISIBILITY_CONFIGURATION',
  GET_DEALER_PANEL_MODEL_QUESTIONS = 'GET_DEALER_PANEL_MODEL_QUESTIONS',
  GET_MODEL_DOCUMENT_VISIBILITY = 'GET_MODEL_DOCUMENT_VISIBILITY',
  CREATE_CONFIGURATION = 'CREATE_CONFIGURATION',
  UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION',
  UPDATE_COMPANY_SETTINGS = 'UPDATE_COMPANY_SETTINGS',
  UPLOAD_COMPANY_LOGO = 'UPLOAD_COMPANY_LOGO',
  IMPORT_PRICE_MATRIX = 'IMPORT_PRICE_MATRIX',
  UPDATE_VERSION = 'UPDATE_VERSION',
  CREATE_CUSTOM_MODEL = 'CREATE_CUSTOM_MODEL',
  SAVE_DRAFT = 'SAVE_DRAFT',
  COPY_VERSION = 'COPY_VERSION',
  ARCHIVE_MODEL = 'ARCHIVE_MODEL',
  RESTORE_MODEL = 'RESTORE_MODEL',
  DELETE_CATEGORY = 'DELETE_CATEGORY',
  ADD_CATEGORY = 'ADD_CATEGORY',
  GET_COMPANY_SUPPLIER_PERMISSIONS_AND_INTENT = 'GET_COMPANY_SUPPLIER_PERMISSIONS_AND_INTENT',
  CHANGE_QUANTITY_CART_LINE = 'CHANGE_QUANTITY_CART_LINE',

  // New keys
  SELECT_COMPANY = 'SELECT_COMPANY',
  CHANGE_ORDER_STATUS = 'CHANGE_ORDER_STATUS',
  RETRY_ORDER = 'RETRY_ORDER',
  UPDATE_FAVORITE_MODEL = 'UPDATE_FAVORITE_MODEL',
  CREATE_NEW_CART = 'CREATE_NEW_CART',
  CHANGE_DISCOUNT_CART_LINE = 'CHANGE_DISCOUNT_CART_LINE',
  DELETE_BUYER = 'DELETE_BUYER',
  ADD_BUYER = 'ADD_BUYER',
  DELETE_BUYER_MODEL = 'DELETE_BUYER_MODEL',
  ADD_MODEL_TO_BUYER = 'ADD_MODEL_TO_BUYER',
  DELETE_MODEL_COMPANY = 'DELETE_MODEL_COMPANY',
  ADD_COMPANY_TO_MODEL = 'ADD_COMPANY_TO_MODEL',
  DELETE_COMPANY_LOGO = 'DELETE_COMPANY_LOGO',
  UPDATE_COMPANY = 'UPDATE_COMPANY',
  ADD_COMPANY_USER = 'ADD_COMPANY_USER',
  DELETE_COMPANY_USER = 'DELETE_COMPANY_USER',
  TOGGLE_ORDER_BUYER_MODEL_INTERNALLY = 'TOGGLE_ORDER_BUYER_MODEL_INTERNALLY',
  TOGGLE_ORDER_BUYER_MODEL_EXTERNALLY = 'TOGGLE_ORDER_BUYER_MODEL_EXTERNALLY',
  TOGGLE_ORDER_ALL_MODELS_INTERNALLY = 'TOGGLE_ORDER_ALL_MODELS_INTERNALLY',
  TOGGLE_ORDER_ALL_MODELS_EXTERNALLY = 'TOGGLE_ORDER_ALL_MODELS_EXTERNALLY',
  TOGGLE_ORDER_MODEL_INTERNALLY_COMPANY = 'TOGGLE_ORDER_MODEL_INTERNALLY_COMPANY',
  TOGGLE_ORDER_MODEL_EXTERNALLY_COMPANY = 'TOGGLE_ORDER_MODEL_EXTERNALLY_COMPANY',
  EDIT_BUYER = 'EDIT_BUYER',
  COMPANY_LOGIN = 'COMPANY_LOGIN',
  CREATE_NEW_ACCOUNT = 'CREATE_NEW_ACCOUNT',
  REGISTER_NEW_COMPANY = 'REGISTER_NEW_COMPANY',
  SELECT_COMPANY_LOGIN = 'SELECT_COMPANY_LOGIN',
  TOGGLE_PUBLIC_MODEL = 'TOGGLE_PUBLIC_MODEL',

  // Configuration questions & options
  CREATE_CONFIGURATION_QUESTION = 'CREATE_CONFIGURATION_QUESTION',
  UPDATE_CONFIGURATION_QUESTION = 'UPDATE_CONFIGURATION_QUESTION',
  PUT_CONFIGURATION_QUESTIONS = 'PUT_CONFIGURATION_QUESTIONS',
  REORDER_CONFIGURATION_QUESTIONS = 'REORDER_CONFIGURATION_QUESTIONS',
  DELETE_CONFIGURATION_QUESTION = 'DELETE_CONFIGURATION_QUESTION',
  CREATE_QUESTION_OPTION = 'CREATE_QUESTION_OPTION',
  UPDATE_QUESTION_OPTION = 'UPDATE_QUESTION_OPTION',
  REORDER_QUESTION_OPTIONS = 'REORDER_QUESTION_OPTIONS',
  DELETE_QUESTION_OPTION = 'DELETE_QUESTION_OPTION',

  // Quotation templates
  CREATE_TEMPLATE = 'CREATE_TEMPLATE',
  UPDATE_TEMPLATE = 'UPDATE_TEMPLATE',
  DELETE_TEMPLATE = 'DELETE_TEMPLATE',
}
